import { Component, OnInit } from "@angular/core";
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute } from "@angular/router";

@Component({
    selector: 'app-otp-auth-error',
    templateUrl: './otp-auth-error.component.html',
    styleUrls: ['./otp-auth-error.component.scss'],
    standalone: false
})
export class OtpAuthErrorComponent implements OnInit {

  constructor(
    public translate: TranslateService,
    public router: Router,
    public route: ActivatedRoute
  ) { }

  ngOnInit(): void { }

  backToEmbeddedRoute() {
    this.router.navigate(['/embedded']);
  }
}
